module.exports = __webpack_public_path__ + "img/_notification.35107e9e.svg";